import { Link } from "react-router-dom";

function HomeSection1() {
    return (
        <section class="text-gray-400 bg-gray-900 body-font">
            <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
                <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                    <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">Get Delivery Drivers. For <div className="inline-block text-red-500">Anything</div>
                    </h1>
                    <p class="mb-8 leading-relaxed">Utilize delivery drivers for getting groceries, restaurant food, clothes, medicine, and more!</p>
                    <div class="flex justify-center">
                        <button class="inline-flex text-white bg-red-500 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg"><Link to="/drivers">Find Drivers</Link></button>
                    </div>
                </div>
                <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
                    <img class="object-cover object-center rounded" alt="hero" src="https://dummyimage.com/720x600"/>
                </div>
            </div>
        </section>
    )
}

export default HomeSection1;